module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<select class="grid4">\n  <option value="" selected="selected">---</option>\n</select>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/ledger.html
// module id = 301
// module chunks = 0